import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import Tooltip from '@material-ui/core/Tooltip';

import { apiOptions, apiPostForm, apiGet } from '../../../../functions/api';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
  customWidth: {
    maxWidth: 300,
  },
  noMaxWidth: {
    maxWidth: 'none',
  },
}));

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

const TuComponente = (props) => {
  const { reload, handleClose, data, acceso } = props;
  const userDepartment = useSelector((form) => form.authUser.departamento);
  const userAuth = useSelector((state) => state.authUser);
  const auth = useSelector((state) => state.authUser.access_token);
  const classes = useStyles();

  const [presupuestos, setPresupuestos] = useState([]);

  const defaultMeses = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiGet(`presupuestosdep/ver/${data.id}`, auth);
        const respuesta = response.data.presupuesto;
        if (Array.isArray(respuesta)) {
          setPresupuestos(respuesta);
        } else {
          console.error('La respuesta de la API no es un array:', respuesta);
        }
      } catch (error) {
        console.error('Error al obtener datos:', error);
      }
    };

    fetchData();
  }, []);

  let acumulados = {};

  // ----------------------------
  // Calcular totales por mes
  // ----------------------------
  let totalesPorMes = {};
  const iniciales = { autorizado: 0, gastado: 0, restante: 0, acumulado: 0 };

  if (presupuestos.length > 0) {
    const mesesActivos = Object.keys(presupuestos[0].mes[0]).filter(m => presupuestos[0].mes[0][m] === 1);
    mesesActivos.forEach(mes => {
      totalesPorMes[mes] = { ...iniciales };
    });

    presupuestos.forEach(presupuesto => {
      const usaNomina = presupuesto.nombre?.toLowerCase().includes('nomina');
      const fuenteMontos = presupuesto.montos_por_mes_por_area;
      const fuenteGasto = usaNomina ? presupuesto.montos_nomina_por_mes : presupuesto.requisiciones_info;

      Object.keys(fuenteMontos).forEach(area => {
        Object.keys(fuenteMontos[area]).forEach(partida => {
          Object.keys(fuenteMontos[area][partida]).forEach(mes => {
            if (presupuesto.mes[0][mes] === 1) {
              const autorizado = fuenteMontos[area][partida][mes] || 0;
              const gastado = fuenteGasto?.[area]?.[partida]?.[mes] || 0;
              const restante = autorizado - gastado;

              if (!totalesPorMes[mes]) totalesPorMes[mes] = { ...iniciales };
              totalesPorMes[mes].autorizado += autorizado;
              totalesPorMes[mes].gastado += gastado;
              totalesPorMes[mes].restante += restante;
            }
          });
        });
      });

      if (presupuesto.montos_por_mes_prestaciones) {
        Object.keys(presupuesto.montos_por_mes_prestaciones).forEach(area => {
          Object.keys(presupuesto.montos_por_mes_prestaciones[area]).forEach(partida => {
            Object.keys(presupuesto.montos_por_mes_prestaciones[area][partida]).forEach(mes => {
              const autorizado = presupuesto.montos_por_mes_prestaciones[area][partida][mes] || 0;
              const gastado = presupuesto.montos_nomina_por_mes?.[area]?.[partida]?.[mes] || 0;
              const restante = autorizado - gastado;

              if (!totalesPorMes[mes]) totalesPorMes[mes] = { ...iniciales };
              totalesPorMes[mes].autorizado += autorizado;
              totalesPorMes[mes].gastado += gastado;
              totalesPorMes[mes].restante += restante;
            });
          });
        });
      }
    });

    // Calcular acumulado mes a mes
    let acumulado = 0;
    defaultMeses.forEach(nombreMes => {
      const mes = nombreMes.toLowerCase();
      if (totalesPorMes[mes]) {
        acumulado += totalesPorMes[mes].restante;
        totalesPorMes[mes].acumulado = acumulado;
      }
    });
  }

  return (
    <div className="table-responsive rounded">
      <div className="table-container">
        <h1>
          {presupuestos[0] ? presupuestos[0].nombre : 'Presupuesto'}
          <LightTooltip title={
            <React.Fragment>
              <Typography color="inherit">Significados de letras</Typography>
              <u>{"A = Autorizado "}</u><br />
              <u>{"G = Gastado "}</u> <br />
              <u>{"R = Restante "}</u> <br />
              <u>{"A = Acumulado "}</u>
            </React.Fragment>
          } classes={{ tooltip: classes.customWidth }}>
            <Button style={{ color: 'red' }} className={classes.button}>? </Button>
          </LightTooltip>
        </h1>

        <table className="table table-xl table-borderless table-vertical-center rounded table-hover">
          <thead>
            <tr>
              <th>Área</th>
              <th>Partida</th>
              {defaultMeses.map((mes, index) =>
                presupuestos[0]?.mes[0]?.[mes.toLowerCase()] === 1 ? <th key={index}>{mes}</th> : null
              )}
            </tr>

            <tr>
              <td colSpan={2}><strong>Totales por mes</strong></td>
              {defaultMeses.map((mes, index) => {
                const key = mes.toLowerCase();
                const t = totalesPorMes[key];
                if (!t) return null;

                return (
                  <td key={index} style={{ whiteSpace: 'nowrap' }}>
                    <span style={{ color: 'red' }}>A:</span> {t.autorizado.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                    <span style={{ color: 'blue' }}>G:</span> {t.gastado.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                    <span style={{ color: 'green' }}>R:</span> {t.restante.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                    <span style={{ color: 'orange' }}>A:</span> {t.acumulado.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                  </td>
                );
              })}
            </tr>
          </thead>

          <tbody>
            <>
              {presupuestos.map((presupuesto, index) => (
                Object.keys(presupuesto.montos_por_mes_por_area).map((area) =>
                  (userAuth.user.tipo.id === 1 || acceso.read === 1 || userDepartment.departamentos[0]['nombre'] === area) && (
                    Object.keys(presupuesto.montos_por_mes_por_area[area]).map((partida) => {
                      return (
                        <tr key={`${area}_${partida}`}>
                          <td>{area}</td>
                          <td>{partida}</td>
                          {presupuesto.montos_por_mes_por_area?.[area]?.[partida] &&
                            Object.keys(presupuesto.montos_por_mes_por_area[area][partida]).map((mes, index) => {
                              const mesAutorizado = presupuesto.mes[0]?.[mes] === 1;
                              if (!mesAutorizado) return null;

                              const valorMontos = presupuesto.montos_por_mes_por_area[area][partida][mes] || 0;
                              const usaNomina = presupuesto.nombre?.toLowerCase().includes('nomina');
                              const valorRequisiciones = usaNomina
                                ? presupuesto.montos_nomina_por_mes?.[area]?.[partida]?.[mes] || 0
                                : presupuesto.requisiciones_info?.[area]?.[partida]?.[mes] || 0;

                              const resultado = valorMontos - valorRequisiciones;
                              const valorMostrado = resultado;

                              const acumuladoAnterior = acumulados[area]?.[partida] || 0;
                              const acumulado = acumuladoAnterior + valorMostrado;
                              acumulados[area] = { ...acumulados[area], [partida]: acumulado };

                              return (
                                <td key={index} style={{ width: 'auto', whiteSpace: 'nowrap' }}>
                                  <span style={{ color: 'red' }}>A:</span>{valorMontos.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                                  <span style={{ color: 'blue' }}>G:</span>{valorRequisiciones.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                                  <span style={{ color: 'green' }}>R:</span>{valorMostrado.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                                  <span style={{ color: 'orange' }}>A:</span>{acumulado.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                                </td>
                              );
                            })}
                        </tr>
                      );
                    })
                  )
                )
              ))}

              {presupuestos.map((presupuesto) => (
                userAuth.user.tipo.id === 1 && (
                  Object.keys(presupuesto.montos_por_mes_prestaciones).map((area) =>
                    Object.keys(presupuesto.montos_por_mes_prestaciones[area]).map((partida) => (
                      <tr key={`${area}_${partida}`}>
                        <td>{area}</td>
                        <td>{partida}</td>
                        {presupuesto.montos_nomina_por_mes?.[area]?.[partida] ?
                          Object.keys(presupuesto.montos_nomina_por_mes[area][partida]).map((mes, index) => {
                            const valorMontos = presupuesto.montos_por_mes_prestaciones?.[area]?.[partida]?.[mes] || 0;
                            const valorRequisiciones = presupuesto.montos_nomina_por_mes?.[area]?.[partida]?.[mes] || 0;

                            const resultado = valorMontos - valorRequisiciones;
                            const valorMostrado = resultado;

                            const acumuladoAnterior = acumulados[area]?.[partida] || 0;
                            const acumulado = acumuladoAnterior + valorMostrado;
                            acumulados[area] = { ...acumulados[area], [partida]: acumulado };

                            return (
                              <td key={index} style={{ width: 'auto', whiteSpace: 'nowrap' }}>
                                <span style={{ color: 'red' }}>A:</span>{valorMontos.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                                <span style={{ color: 'blue' }}>G:</span>{valorRequisiciones.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                                <span style={{ color: 'green' }}>R:</span>{valorMostrado.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                                <span style={{ color: 'orange' }}>A:</span>{acumulado.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })}<br />
                              </td>
                            );
                          }) : (
                            <td colSpan={14}>Sin registros</td>
                          )}
                      </tr>
                    ))
                  )
                )
              ))}
            </>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TuComponente;
